import { useCallback, useContext } from 'react'
import { GlobalSearchStateContext } from 'contexts/GlobalSearch/GlobalSearchContexts'
import { ISO_DATE_FORMAT } from 'constants/dateFormats'
import ExperiencesSearchDateQuickChips, {
  CHIP_ANYTIME,
  type ExperiencesDateQuickChipSelectPayload,
} from 'components/Search/Experiences/ExperiencesSearchDateQuickChips'
import useExperiencesSearchDateDispatch from 'components/Experiences/hooks/useExperiencesSearchDateDispatch'
import useExperiencesSearchFilters from 'components/Experiences/hooks/useExperiencesSearchFilters'
import useTrackExperienceSearchFilter from 'components/Experiences/hooks/useTrackExperienceSearchFilter'

interface Props {
  showNextBooking?: boolean
  displayType?: 'single-line' | 'multi-line'
}

function ExperienceSearchDateFilter({
  showNextBooking = true,
  displayType = 'multi-line',
}: Props) {
  const { checkinDate, checkoutDate, dateSearchOptionId } = useContext(GlobalSearchStateContext)
  const { selectAnytime, selectDayRange } = useExperiencesSearchDateDispatch()
  const { searchFilters, setSearchFilters } = useExperiencesSearchFilters()
  const trackSearchFilter = useTrackExperienceSearchFilter()

  const onSelect = useCallback((payload: ExperiencesDateQuickChipSelectPayload) => {
    trackSearchFilter({
      label: 'Date',
      type: 'date',
      value: payload.value,
    })

    if (payload.value === CHIP_ANYTIME || !payload.range) {
      selectAnytime()
      setSearchFilters({ ...searchFilters, checkIn: undefined, checkOut: undefined, date: undefined })
      return
    }

    const { start, end } = payload.range
    selectDayRange(start, end)
    setSearchFilters({ ...searchFilters, checkIn: start.format(ISO_DATE_FORMAT), checkOut: end.format(ISO_DATE_FORMAT), date: undefined })
  }, [selectAnytime, selectDayRange, searchFilters, setSearchFilters, trackSearchFilter])

  return (
    <ExperiencesSearchDateQuickChips
      checkinDate={checkinDate}
      checkoutDate={checkoutDate}
      dateSearchOptionId={dateSearchOptionId}
      onSelect={onSelect}
      displayType={displayType}
      showNextBooking={showNextBooking}
    />
  )
}

export default ExperienceSearchDateFilter
